import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import withWidth from '@material-ui/core/withWidth';

import ResourceList from '../share/ResourceList';
import { resourceFields, locationPaginationCount, deliveryAndCateringZonesButtonArray } from '../../data/Constants';
import { Paper, Typography, withStyles } from '@material-ui/core';
import { commonResourceStyle } from '../../css/style';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';
import * as types from '../../redux/resource/ResourcesActionTypes';
import * as Functions from '../../utils/Functions';
import { checkIsLocationAdmin } from '../../utils/AuthorizationChecks';
import BasicToolBar from '../share/BasicToolBar';
import AdditionalLocationMenuItems from './AdditionalLocationMenuItems';

const styles = commonResourceStyle();

class Locations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filteredLocations: [],
      searchedTerm: null,
    };
  }

  componentDidMount = async () => {
    await this.getLocationsResources();
  }

  componentDidUpdate = async (prevProps) => {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getLocationsResources();
    }
  }

  getLocationsResources = async () => {
    const {
      locations, actions, loading, apiToken, admin,
    } = this.props;

    if (loading === false && !locations) {
    }

    // The full location list is needed to find a location admin's matching location
    const queryParams = admin && checkIsLocationAdmin(admin)
      ? 'locations'
      : `locations?start=0&count=${locationPaginationCount}`;
    await actions.getAllResources(apiToken, queryParams);
    this.setState({
      filteredLocations: locations,
    });
  }

  handleSearch = (term) => {
    const { locations } = this.props;
    const searchEntityResult = Functions.searchEntity(term, locations, 'name');
    this.setState({
      filteredLocations: searchEntityResult,
      searchedTerm: term,
    });
  }

  handleClearSearch = () => {
    this.setState({
      searchedTerm: '',
      filteredLocations: [],
    });
  }

  onClickViewMore = async () => {
    const {
      actions,
      apiToken,
      pagination,
      loading,
    } = this.props;
    if (!loading) {
      const queryParams = `locations?start=${pagination.start + pagination.count}&count=${locationPaginationCount}`;
      actions.updateLoadingState(types.VIEW_MORE_RESOURCE_REQUESTED);
      await actions.getAllResources(apiToken, queryParams);
      actions.updateLoadingState(types.VIEW_MORE_RESOURCE_SUCCESS);
    }
  }

  render() {
    const {
      locations, actions, loading, apiToken, match, viewMoreLoading, pagination, width,
    } = this.props;
    const { resource } = match.params;
    const { searchedTerm, filteredLocations } = this.state;
    const mutableLocations = cloneDeep(locations);
    if (mutableLocations && mutableLocations.length != 0) {
      mutableLocations.push({ id: 'viewMore', value: 'VIEW MORE' });
    }

    return (
      (loading === true && viewMoreLoading === 0)
        ? <LoadingBar />
        : (
          <div style={styles.container}>
            <div style={styles.resourceHeader}>
              <div style={styles.resourceName}>
                <Typography style={styles.resourceName}>Locations</Typography>
              </div>
              <div style={styles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} />
              </div>
            </div>
            <Paper style={styles.paper}>
              <BasicToolBar
                actions={actions}
                resourceName={resource}
                handleSearch={this.handleSearch}
                handleClearSearch={this.handleClearSearch}
              />
              <ResourceList
                data={searchedTerm ? filteredLocations : mutableLocations}
                actions={actions}
                fieldNames={resourceFields.locations}
                resourceName={resource}
                buttonArray={deliveryAndCateringZonesButtonArray}
                apiToken={apiToken}
                onClickViewMore={this.onClickViewMore}
                totalResource={pagination && pagination.totalSize}
                viewMoreLoading={viewMoreLoading}
                admin={this.props.admin}
                isTablet={Functions.isDeviceView('md', width)}
                showAdditionalLocationMenuItems
              />
            </Paper>
          </div>
        )
    );
  }
}

Locations.propTypes = {
  loading: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
  admin: PropTypes.object,
};

Locations.defaultProps = {
  locations: null,
};

export default withWidth()(withStyles(commonResourceStyle)(withRouter(Locations)));
